import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import TextField from "@mui/material/TextField";
import { moment } from "../../../../../utils/LocalizedUtils";

const InfoModalFieldComponent = ({ value, translation, language, translationKey, date, note }) => {
  const isEmpty = value === "" || value === -1;
  const calcValue = () => {
    if (value !== "" && value !== -1 && date)
      return moment(value + (new Date().getTimezoneOffset() / -60) * 3600000)
        .locale(language)
        .format("LLLL");
    if (date) return translation.notGiven;
    if (value !== "" && value.toString() !== "-1") return value;
    if (note) return translation.notesNotGiven;
    return translation.notGiven;
  };
  return (
    <TextField
      id={translationKey}
      label={translation[translationKey]}
      sx={theme => ({
        m: 1,
        flexGrow: 1,
      })}
      padding="normal"
      value={calcValue()}
      slotProps={{
        input: {
          readOnly: true,
          sx: isEmpty ? { color: "rgba(0, 0, 0, 0.5)" } : undefined,
        },
      }}
      multiline={note}
      variant={note ? "outlined" : "standard"}
    />
  );
};

InfoModalFieldComponent.defaultProps = {
  note: false,
  date: false,
  value: "",
};

InfoModalFieldComponent.propTypes = {
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  translation: PropTypes.object.isRequired,
  translationKey: PropTypes.string.isRequired,
  note: PropTypes.bool,
  date: PropTypes.bool,
  language: PropTypes.string.isRequired,
};

const mapStateToProps = state => ({
  translation: state.ui.translate,
  language: state.ui.language,
});

const InfoModalField = connect(mapStateToProps)(InfoModalFieldComponent);

export default InfoModalField;
